import { FiMonitor, FiLayout, FiSmartphone, FiZap, FiGlobe, FiTrendingUp, FiCpu, FiCode, FiLayers, FiCheckCircle, FiShield } from "react-icons/fi";
import { FaReact, FaAngular, FaVuejs, FaJs } from "react-icons/fa";
import { SiNextdotjs, SiTailwindcss, SiTypescript, SiFramer } from "react-icons/si";
import { LuSettings, LuSearch, LuShield, LuUsers, LuSmartphone, LuShieldCheck, LuCircleCheck, LuPercent, LuRocket, LuCode, LuPalette, LuClipboardList } from "react-icons/lu";

export const frontendHeroData = {
  backgroundImage: "/images/serviceBanners/FrontEndTechnologies.webp",
  whiteImage: "/images/serviceBanners/FrontendW.webp",
  subTitle: "Building High-Performance Frontend Applications",
  title: (
    <>
      Modern Frontend Web <br /> Applications & <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">Digital Experiences</span>
    </>
  ),
  description:
    "We build fast, scalable, and responsive frontend applications that deliver smooth user experiences, improve engagement, and strengthen digital product performance.",
  primaryButton: {
    title: "Get a Free Audit",
    onClick: () => console.log("Frontend Start"),
  },
  secondaryButton: {
    title: "View UI Gallery",
    onClick: () => console.log("Frontend Work"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "Fast & Scalable Performance",
      desc: "Optimized frontend for speed and smooth user experience.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Fully Responsive Design",
      desc: "Seamless performance across all devices and screen sizes.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Secure Web Architecture",
      desc: "Built with modern security standards and scalable structure.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "User-Focused Development",
      desc: "Clean and intuitive interfaces for better user engagement.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/icons/rwacticon.webp",
      top: "16%",
      right: "6%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(97,218,251,0.35)",
      iconGlow: "rgba(97,218,251,0.9)",
    },
  ],
};
// 2. Stats Block
export const frontendStatsData = [
  {
    icon: LuSettings,
    value: "150+",
    label: "Apps Built",
    colorClass: "text-[#00d2ff]",
    bgClass: "bg-[#00d2ff]/10",
    borderClass: "border-[#00d2ff]/20",
    glowClass: "shadow-[0_0_20px_rgba(0,210,255,0.15)]",
  },
  {
    icon: LuUsers,
    value: "90+",
    label: "Happy Clients",
    colorClass: "text-[#a855f7]",
    bgClass: "bg-[#a855f7]/10",
    borderClass: "border-[#a855f7]/20",
    glowClass: "shadow-[0_0_20px_rgba(168,85,247,0.15)]",
  },
  {
    icon: LuSmartphone,
    value: "50M+",
    label: "Downloads",
    colorClass: "text-[#06b6d4]",
    bgClass: "bg-[#06b6d4]/10",
    borderClass: "border-[#06b6d4]/20",
    glowClass: "shadow-[0_0_20px_rgba(6,182,212,0.15)]",
  },
  {
    icon: LuShieldCheck,
    value: "99.9%",
    label: "Crash-Free Apps",
    colorClass: "text-[#3b82f6]",
    bgClass: "bg-[#3b82f6]/10",
    borderClass: "border-[#3b82f6]/20",
    glowClass: "shadow-[0_0_20px_rgba(59,130,246,0.15)]",
  },
  {
    icon: LuPercent,
    value: "40%",
    label: "Faster Development",
    colorClass: "text-[#d946ef]",
    bgClass: "bg-[#d946ef]/10",
    borderClass: "border-[#d946ef]/20",
    glowClass: "shadow-[0_0_20px_rgba(217,70,239,0.15)]",
  },
  {
    icon: LuShield,
    value: "100%",
    label: "Client Satisfaction",
    colorClass: "text-[#6366f1]",
    bgClass: "bg-[#6366f1]/10",
    borderClass: "border-[#6366f1]/20",
    glowClass: "shadow-[0_0_20px_rgba(99,102,241,0.15)]",
  },
];

export const frontendServices = [
  {
    icon: <img src="/images/icons/reactnative.webp" alt="React JS" className="w-12 h-9" />,
    title: "ReactJS Development",
    description: "Build fast and interactive frontend applications using React for dynamic and scalable user experiences.",
    image: "/images/WebAppDevelopment/React_JS_Development.png",
    link: "/reactjs-development-services-india",
  },
  {
    icon: <img src="/images/icons/angular-icon.svg" alt="Angular" className="w-12 h-9" />,
    title: "Angular Development",
    description: "Develop enterprise-grade frontend applications with Angular for structured, scalable, and high-performance web systems.",
    image: "/images/WebAppDevelopment/Angular_Development.png",
    link: "/angular-development-services-india",
  },
  {
    icon: <img src="/images/icons/vuejs.webp" alt="Vue JS" className="w-12 h-9" />,
    title: "Vue JS Development",
    description: "Create lightweight and flexible web interfaces using Vue for smooth and modern user experiences.",
    image: "/images/WebAppDevelopment/Vue_JS_Development.png",
    link: "/vuejs-development-services-india",
  },
  {
    icon: <img src="/images/icons/solidjs.webp" alt="Solid JS" className="w-12 h-9" />,
    title: "Solid JS Development",
    description: "Build highly efficient and reactive frontend applications with minimal overhead and maximum performance.",
    image: "/images/WebAppDevelopment/Solid_JS_Development.png",
    link: "/solidjs-development-services-india",
  },
  {
    icon: <img src="/images/icons/nextjs.webp" alt="Next.js" className="w-12 h-9" />,
    title: "Next.js Development",
    description: "Develop SEO-friendly and server-rendered web applications with Next.js for better performance and visibility.",
    image: "/images/WebAppDevelopment/Next_JS_Development.png",
    link: "/nextjs-development-services-india",
  },
];
export const frontendSolutionsAndProcessData = {
  buildSubtitle: "OUR CAPABILITIES",
  buildTitle: "Frontend Development Solutions for Every Business Need",
  buildCards: [
    {
      title: "Cross-Platform Frontend Development",
      desc: "Build high-performance web interfaces that work smoothly across all devices and platforms.",
      icon: FaReact,
      colorClass: "text-[#61dafb]",
      bgClass: "bg-[#61dafb]/10",
      borderClass: "border-[#61dafb]/20 hover:border-[#61dafb]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(97,218,251,0.25)]",
    },
    {
      title: "Enterprise Frontend Solutions",
      desc: "Develop scalable and secure frontend systems for complex business applications.",
      icon: SiNextdotjs,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "E-Commerce Frontend Development",
      desc: "Create fast and conversion-focused shopping experiences with modern UI.",
      icon: FaAngular,
      colorClass: "text-[#dd0031]",
      bgClass: "bg-[#dd0031]/10",
      borderClass: "border-[#dd0031]/20 hover:border-[#dd0031]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(221,0,49,0.25)]",
    },
    {
      title: "On-Demand Frontend Solutions",
      desc: "Build real-time responsive interfaces for booking and service platforms.",
      icon: FaVuejs,
      colorClass: "text-[#42b883]",
      bgClass: "bg-[#42b883]/10",
      borderClass: "border-[#42b883]/20 hover:border-[#42b883]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(66,184,131,0.25)]",
    },
    {
      title: "FinTech Frontend Development",
      desc: "Design secure and data-driven financial user interfaces with clean UX.",
      icon: FiShield,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "Custom Frontend Development",
      desc: "Develop tailored frontend solutions based on business goals and user needs.",
      icon: FiLayers,
      colorClass: "text-[#f59e0b]",
      bgClass: "bg-[#f59e0b]/10",
      borderClass: "border-[#f59e0b]/20 hover:border-[#f59e0b]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(245,158,11,0.25)]",
    },
  ],
  processSubtitle: "OUR METHODOLOGY",
  processTitle: "Frontend Development Process",
  processSteps: [
    {
      step: "01",
      title: "Discovery & Consultation",
      description: "Understand business goals, target audience, and frontend requirements.",
      icon: LuSearch,
    },
    {
      step: "02",
      title: "Strategy & Planning",
      description: "Define architecture, tech stack, and development roadmap.",
      icon: LuClipboardList,
    },
    {
      step: "03",
      title: "UI/UX Design",
      description: "Create modern, intuitive, and user-friendly interface designs.",
      icon: LuPalette,
    },
    {
      step: "04",
      title: "Development",
      description: "Build scalable and high-performance frontend applications with clean architecture.",
      icon: LuCode,
    },
    {
      step: "05",
      title: "Quality Testing",
      description: "Test responsiveness, performance, and cross-browser compatibility templates.",
      icon: LuCircleCheck,
    },
    {
      step: "06",
      title: "Deployment & Support",
      description: "Launch application and provide continuous updates and maintenance tracking.",
      icon: LuRocket,
    },
  ],
  benefitsSubtitle: "WHY CHOOSE OUR FRONTEND DEVELOPMENT SERVICES?",
  benefitsTitle: "Why Businesses Choose Frontend Development Solutions",
  benefits: ["Cross-platform support", "Faster development", "Modern UI design", "Smooth performance", "Efficient workflow", "Scalable solutions", "Cost-effective approach"],
  logoImage: "/images/serviceBanners/FrontEndTechnologies.webp",
  whiteLogoImage: "/images/serviceBanners/FrontendW.webp",
};

// 4. Portfolio Data
export const frontendPortfolioData = {
  subtitle: "SUCCESS STORIES",
  title: "Interfaces That Engage",
  buttonText: "View Case Studies",
  buttonLink: "#",
  apps: [
    {
      title: "SaaS Dashboard 2.0",
      badge: "Enterprise UI",
      badgeColor: "bg-[#00d2ff]/10 text-[#00d2ff] border-[#00d2ff]/20",
      desc: "A complex analytics portal built with React and D3.js handling 1M+ data points.",
      downloads: "Active Users",
      rating: "5.0",
      image: "/images/WebAppDevelopment/React_JS_Development.png",
    },
  ],
};

// 5. Technologies Data
export const frontendTechnologiesData = {
  techTitle: "OUR FRONTEND STACK",
  technologies: [
    { name: "React", icon: "ReactJS" },
    { name: "Next.js", icon: "RestAPI" }, // Mock icon mapping
    { name: "TypeScript", icon: "Dart" }, // Mock icon mapping
    { name: "Tailwind CSS", icon: "Vite" },
    { name: "Angular", icon: "Provider" },
    { name: "Framer Motion", icon: "Styled" },
  ],
  trustTitle: "TRUSTED BY TECHNOLOGY LEADERS",
  trustClients: [
    { image: "/images/logo/google_logo.png", alt: "google_logo" },
    { image: "/images/logo/microsoft_logo.png", alt: "microsoft_logo" },
    { image: "/images/logo/amazon_logo.png", alt: "amazon_logo" },
    { image: "/images/logo/Adobe_Corporate_logo.png", alt: "adobe_logo" },
    { image: "/images/logo/IBM_logo.png", alt: "ibm_logo" },
    { image: "/images/logo/Oracle_logo.png", alt: "oracle_logo" },
  ],
};

// 6. About Overview
export const frontendAboutData = [
  {
    title: "Frontend App Development Services for Better Digital Experiences",
    content: (
      <>
        Modern businesses need digital products that are fast, responsive, and easy to interact with across devices. Reliable{" "}
        <b className="text-text-primary font-semibold">frontend app development services</b> help organizations create smooth user experiences that improve engagement and
        strengthen product usability. Many businesses struggle with outdated interfaces, inconsistent performance, and poor customer interaction that affect retention. At{" "}
        <b className="text-text-primary font-semibold">Tycho Technologies</b>, frontend systems are developed around usability, scalability, and business objectives to help brands
        deliver better digital experiences with long-term value.
      </>
    ),
  },
  {
    title: "Frontend Development Company for Scalable Applications",
    content: (
      <>
        A successful digital product depends heavily on how users interact with it. A trusted <b className="text-text-primary font-semibold">frontend development company</b> helps
        businesses create structured and visually clear interfaces that improve accessibility and simplify navigation. Companies investing in{" "}
        <b className="text-text-primary font-semibold">custom frontend development services</b> often improve customer engagement because applications become easier to use and more
        intuitive across platforms. Tycho Technologies focuses on practical frontend frameworks designed to support business performance while adapting to changing user
        expectations and technology trends.
      </>
    ),
  },
  {
    title: "Frontend App Development Company Focused on User Experience",
    content: (
      <>
        Strong interfaces improve how customers interact with products and services, leading to higher satisfaction and retention. A reliable{" "}
        <b className="text-text-primary font-semibold">frontend app development company</b> helps organizations build digital experiences that support usability and consistent
        interaction quality. Businesses looking to strengthen performance often align frontend improvements with{" "}
        <a href="https://tychotechnologies.com/web-app-development-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          web app development services
        </a>{" "}
        to create connected systems that improve functionality and support scalable growth.
      </>
    ),
  },
  {
    title: "Why Businesses Choose Frontend Development Services in India",
    content: (
      <>
        The demand for trusted <b className="text-text-primary font-semibold">frontend development services in india</b> continues to grow as businesses prioritize performance,
        usability, and long-term digital scalability. Companies seek solutions that support better interaction while maintaining flexibility for future product growth. Businesses
        partnering with Tycho Technologies benefit from tailored frontend strategies designed around measurable outcomes and user behavior. Many organizations also improve modern
        web experiences through{" "}
        <a href="https://tychotechnologies.com/reactjs-development-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          react js development services
        </a>{" "}
        to build faster and more dynamic digital applications.
      </>
    ),
  },
];
// 7. FAQs (Preserved)
export const frontendFaqs = [
  {
    q: "Why should I choose ReactJS for my project?",
    a: "React's component-based architecture and massive ecosystem make it ideal for building scalable, maintainable, and high-performance apps.",
  },
  {
    q: "How do you ensure the website is fast?",
    a: "We use techniques like code splitting, lazy loading, image optimization, and SSR (Server Side Rendering) with Next.js.",
  },
];
